// @mui material components
import Container from "@mui/material/Container";
import { Grid, Card, Divider } from "@mui/material";
import MDTypography from "dashboard/components/MDTypography";
import MDBox from "dashboard/components/MDBox";
// Material Kit 2 React examples
import CounterCard from "dashboard/examples/Cards/CounterCard";
import Brevet from "assets/images/icons/diplome.png";
import House from "assets/images/icons/logement-social.png";
import productBox from "assets/images/icons/boite-de-livraison.png";
import finished from "assets/images/icons/crochet.png";
import { width } from "@mui/system";

const imagStyle= {
  objectFit:"cover",
  width : "30%",
  display: "block", 
  margin: "auto",
  veticalAlign : "baseline",
  filter : 'invert(.5)',
  p : 2
}
function Counters() {
  return (
    <Card id="counter" component="section"  py={3}>
      <Container>
        <MDTypography sx={{my:3, textAlign:"center", textTransform :"uppercase"}} variant="h2">Une solution pour chaque besoin</MDTypography>
        <Grid container item xs={12}  sx={{ mx: "auto" }}>
          <Grid item xs={12} md={3}>
            <CounterCard
              icon={<MDBox sx={imagStyle} component="img" src={Brevet} />}
              count={70}
              title="Brevets"
              description="Brevets déposés par an"
            />
          </Grid>
          <Grid item xs={12} md={3} display="flex">
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, mx: 0 }} />
            
            <CounterCard
              icon={<MDBox sx={imagStyle} component="img" src={House} />}
              count={100}
              suffix=" k"
              title="Logements"
              description="réalisés avec nos solutions"
            />
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, ml: 0 }} />
          </Grid>
          <Grid item xs={12} display="flex" md={3}>  
            <CounterCard
              icon={<MDBox sx={imagStyle} component="img" src={productBox} />}
              count={500}
              title="Produits"
              description="développés au sein de nos laboratoires"
            />
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, mx: 0 }} />
          </Grid>
          <Grid item xs={12} md={3}>
            <CounterCard
              icon={<MDBox sx={imagStyle} component="img" src={finished} />}
              count={50}
              suffix="+"
              title="Travaux effectués"
              description="sur barrages avec les solutions GRANITEX"
            />
          </Grid>
        </Grid>
      </Container>
    </Card>
  );
}

export default Counters;
